import log from 'loglevel';



class Logger {
  constructor(fileName, level) {
    if (log) {
      log.setLevel(
        level ??
          process.env.NODE_ENV === 'production'
            ? 'INFO'
            : 'DEBUG'
      );
      this.loggerInstance = log;
    }
    else {
      this.loggerInstance = console;
    }
    this.fileName = fileName;
  }

  debug() {
    this.loggerInstance.debug(`[${this.fileName}]`, arguments);
  }

  error() {
    this.loggerInstance.error(`[${this.fileName}]`, arguments);
  }

  info() {
    this.loggerInstance.info(`[${this.fileName}]`, arguments);
  }

  trace() {
    this.loggerInstance.trace(`[${this.fileName}]`, arguments);
  }

  warn() {
    this.loggerInstance.warn(`[${this.fileName}]`, arguments);
  }
}

const getLogger = (filePath) => {
  let fileName;
  try {
    fileName = fileURLToPath(filePath);
  } 
  catch(e) {
    fileName = 'Unprovided path';
  }
  return new Logger(fileName);
};

export default getLogger;